import { OrderTabs } from "@/components/screens/OrderFormPage/types";
import { OrderFormPageMessages } from "@/messages/order-form-page/order-form-page.messages";
import { PaymentDataTabMessages } from "@/messages/order-form-page/payment-data-tab.messages";
import { TabItem } from "@/types/form.types";

export const TABS_ITEMS = (
  messages: OrderFormPageMessages,
  isEditing: boolean
): TabItem<OrderTabs>[] => {
  const tabs: TabItem<OrderTabs>[] = [
    { value: "orderDataTab", label: messages.orderDetailsTabLabel },
    { value: "itemDataTab", label: messages.orderItemsTabLabel },
    { value: "paymentDataTab", label: messages.orderPaymentsTabLabel },
  ];

  if (isEditing) {
    tabs.push({ value: "commentsDataTab", label: messages.orderCommentsTabLabel });
    tabs.push({ value: "historyTab", label: messages.orderHistoryTabLabel });
  }

  return tabs;
};

export const PAYMENTS_TABLE_COLUMNS = (messages: PaymentDataTabMessages) => [
  messages.paymentDateColumn,
  messages.paymentMethodColumn,
  messages.paymentAmountColumn,
  messages.optionsColumn,
];

export const shippingToBillingFields = {
  shippingDocumentType: "billingDocumentType",
  shippingDocument: "billingDocument",
  shippingName: "billingName",
  shippingGender: "billingGender",
  shippingPersonType: "billingPersonType",
  shippingPhoneNumber: "billingPhoneNumber",
  shippingEmail: "billingEmail",
  shippingAddress: "billingAddress",
  shippingAddressNumber: "billingAddressNumber",
  shippingAddressCompl: "billingAddressCompl",
  shippingAddressDistrict: "billingAddressDistrict",
  shippingAddressCity: "billingAddressCity",
  shippingAddressState: "billingAddressState",
  shippingAddressZipcode: "billingAddressZipcode",
  shippingAddressCountry: "billingAddressCountry",
};
